import toCamelCase from '@/helpers/toCamelCase';

export const SOCIAL_MEDIA_PRIMARY_ICON_VARIANT = 'primary';

function buildIcons(primaryIconName, variants = [], type = 'svg') {
    const iconsFromVariants = {};

    for (const variant of variants) {
        const propertyName = variant?.label || variant.source;

        iconsFromVariants[
            propertyName
        ] = require(`@/assets/images/network-logos/${primaryIconName}-${variant.source}.${type}`);
    }

    return {
        [SOCIAL_MEDIA_PRIMARY_ICON_VARIANT]: require(`@/assets/images/network-logos/${primaryIconName}.${type}`),
        ...toCamelCase(iconsFromVariants)
    };
}

const defaultVariants = [{ source: 'black' }, { source: 'white' }];

const socialMedia = {
    twitter: {
        id: 1,
        shortname: 'x',
        name: 'X',
        color: '#1da1f2',
        chartColor: '#1da1f2',
        selectColor: '#1da1f2',
        icons: buildIcons('twitter', []),
        socialName: 'twitter',
        sortable: true
    },

    instagram: {
        id: 2,
        shortname: 'ig',
        name: 'Instagram',
        color: '#e1306c',
        chartColor: '#e1306c',
        selectColor: '#e1306c',
        icons: buildIcons('ig', defaultVariants),
        socialName: 'ig',
        sortable: true
    },

    facebook: {
        id: 3,
        shortname: 'fb',
        name: 'Facebook',
        color: '#4267b2',
        chartColor: '#4267b2',
        selectColor: '#4267b2',
        icons: buildIcons('fb', defaultVariants),
        socialName: 'fb',
        sortable: true
    },

    reddit: {
        id: 4,
        name: 'Reddit',
        color: '#FF4500',
        chartColor: '#FF4500',
        selectColor: '#FF4500',
        shortname: 'rd',
        icons: buildIcons('reddit', []),
        socialName: 'rd',
        sortable: true
    },

    youtube: {
        id: 5,
        name: 'Video',
        color: '#FFF',
        chartColor: '#FF0000',
        selectColor: '#000000',
        shortname: 'ytb',
        icons: buildIcons('video', [{ source: 'small' }]),
        socialName: 'ytb',
        sortable: true
    },

    article: {
        id: 6,
        name: 'Discussions',
        color: '#16D7AC',
        chartColor: '#16D7AC',
        selectColor: '#16D7AC',
        shortname: 'Discussions',
        icons: buildIcons('articles', []),
        socialName: 'article',
        sortable: false
    },

    ios: {
        id: 7,
        name: 'App Store',
        color: '#1890FF',
        chartColor: '#1890FF',
        selectColor: '#1890FF',
        shortname: 'ios',
        icons: buildIcons('app-store', [{ source: 'reviews' }]),
        socialName: 'ios',
        sortable: false
    },

    trustpilot: {
        id: 8,
        name: 'Trustpilot',
        color: '#01D4A6',
        chartColor: '#01D4A6',
        selectColor: '#01D4A6',
        shortname: 'tp',
        icons: buildIcons('trustpilot', [...defaultVariants, { source: 'reviews' }]),
        socialName: 'tp',
        sortable: true
    },

    discourse: {
        id: 9,
        name: 'Discourse',
        color: '#FFF9AE',
        chartColor: '#FFF9AE',
        selectColor: '#494630',
        shortname: 'discourse',
        icons: buildIcons('discourse', []),
        socialName: 'discourse',
        sortable: true
    },

    googlePlay: {
        id: 10,
        name: 'Google Play',
        color: '#2E2E2E',
        chartColor: '#2E2E2E',
        selectColor: '#2E2E2E',
        shortname: 'gp',
        icons: buildIcons('google-play-post', [...defaultVariants, { source: 'reviews' }]),
        socialName: 'gp',
        sortable: false
    },

    linkedin: {
        id: 11,
        name: 'Linkedin',
        color: '#007BB5',
        chartColor: '#007BB5',
        selectColor: '#007BB5',
        shortname: 'li',
        icons: buildIcons('linkedin', defaultVariants),
        socialName: 'li',
        sortable: true
    },

    webreview: {
        id: 12,
        name: 'Reviews',
        color: '#BD10E0',
        chartColor: '#BD10E0',
        selectColor: '#BD10E0',
        shortname: 'webreview',
        icons: buildIcons('reviews-forums', []),
        socialName: 'webreview',
        sortable: false
    },

    etoro: {
        id: 13,
        name: 'eToro',
        color: '#69AE00',
        chartColor: '#69AE00',
        selectColor: '#69AE00',
        shortname: 'etoro',
        icons: buildIcons('etoro', [{ source: 'verified' }]),
        socialName: 'etoro',
        sortable: true
    },

    wixan: {
        id: 14,
        name: 'Wix Answers',
        color: '#3C6484',
        chartColor: '#3C6484',
        selectColor: '#3C6484',
        shortname: 'wix',
        icons: buildIcons('wix-answers-post', []),
        socialName: 'wixan',
        sortable: true
    },

    discord: {
        id: 15,
        name: 'Discord',
        color: '#758AD4',
        chartColor: '#758AD4',
        selectColor: '#758AD4',
        shortname: 'discord',
        icons: buildIcons('discord', defaultVariants),
        socialName: 'discord',
        sortable: true
    },

    vanillaForums: {
        id: 16,
        name: 'Vanilla Forums',
        color: '#0192DC',
        chartColor: '#0192DC',
        selectColor: '#0192DC',
        shortname: 'vanilla',
        icons: buildIcons('vanilla', defaultVariants),
        socialName: 'vanilla',
        sortable: true
    },

    zendesk: {
        id: 17,
        name: 'Zendesk',
        color: '#03363D',
        chartColor: '#03363D',
        selectColor: '#03363D',
        shortname: 'zendesk',
        icons: buildIcons('zendesk', defaultVariants),
        socialName: 'zendesk',
        sortable: false
    },

    tiktok: {
        id: 18,
        name: 'Tiktok',
        color: '#000000',
        chartColor: '#000000',
        selectColor: '#000000',
        shortname: 'tiktok',
        icons: buildIcons('tiktok', []),
        socialName: 'tiktok',
        sortable: true
    },

    intercom: {
        id: 19,
        name: 'Intercom',
        color: '#288BE4',
        chartColor: '#288BE4',
        selectColor: '#288BE4',
        shortname: 'intercom',
        icons: buildIcons('intercom', defaultVariants),
        socialName: 'intercom',
        sortable: false
    },

    helpshift: {
        id: 20,
        name: 'Helpshift',
        color: '#0C7554',
        chartColor: '#0C7554',
        selectColor: '#0C7554',
        shortname: 'helpshift',
        icons: buildIcons('helpshift', []),
        socialName: 'helpshift',
        sortable: false
    },

    steam: {
        id: 21,
        name: 'Steam',
        color: '#111D2F',
        chartColor: '#111D2F',
        selectColor: '#111D2F',
        shortname: 'steam',
        icons: buildIcons('steam', [{ source: 'reviews' }]),
        socialName: 'steam',
        sortable: true
    },

    fmKorea: {
        id: 22,
        name: 'FM Korea',
        color: '#446DC1',
        chartColor: '#446DC1',
        selectColor: '#446DC1',
        shortname: 'fmKorea',
        icons: buildIcons('fm-korea', []),
        socialName: 'fm_korea',
        sortable: true
    },

    weibo: {
        id: 23,
        name: 'Weibo',
        color: '#FEDA4D',
        chartColor: '#FEDA4D',
        selectColor: '#FEDA4D',
        shortname: 'weibo',
        icons: buildIcons('weibo', []),
        socialName: 'weibo',
        sortable: true
    },

    xhs: {
        id: 24,
        name: 'Xiaohongshu',
        color: '#FFFFFF',
        chartColor: '#FF3349',
        selectColor: '#000000',
        shortname: 'xhs',
        icons: buildIcons('xhs', []),
        socialName: 'xhs',
        sortable: true
    },

    getById(id) {
        let result;

        const socialKey = Object
            .keys(this)
            .filter(key => typeof this[key] === 'object')
            .find(key => this[key].id === id);

        if (socialKey) { result = this[socialKey]; }

        return result;
    },

    getAll() {
        return Object
            .keys(this)
            .filter(key => typeof this[key] === 'object')
            .map(key => this[key]);
    }
};

export default socialMedia;

const { googlePlay, trustpilot, ios, webreview, steam } = socialMedia;

export const REVIEWS_KEY_NETWORKS = [googlePlay.shortname, trustpilot.shortname, ios.shortname, webreview.shortname, steam.shortname];
